import {createPluginFromSingleComponentPlugin} from '../../pluginsFactory'
import {pack} from './pack'
import {unpack} from './unpack'

export const wPhotoPlugin = createPluginFromSingleComponentPlugin({
    name: 'WPhotoPlugin',
    components: new Set(['WPhoto']),
    pack,
    unpack
})
